module.exports = __webpack_public_path__ + "static/media/prize_moncacaoImage.63c475cb.png";